import React, { useLayoutEffect, useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IoArrowBackCircleOutline } from 'react-icons/io5';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import Load from 'components/Load';
import ItensMenuContext from 'context/ItensMenuContext';
import { respFakeItem } from 'types/ElementMenuProps';
import AddBtn from 'components/AddBtn';
import ItemFromItemMenu from 'components/ItemFromItemMenu';
import FormItemMenuSelected from 'components/FormItemMenuSelected';
import { getElementsId } from './reqs';

export default function ItemMenuSelected() {
	const navigate = useNavigate();
	const { i18n, t }: UseTranslationProps = useTranslation();
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const {
		setItensFromElement,
		setIsLoad,
		isLoad,
		itensFromElement,
		isFormOpen,
		setIsFormOpen
	} = useContext(ItensMenuContext);

	const { slug } = useParams<{ slug: string }>();

	//busca dados dos itens
	useEffect(() => {
		if (slug) {
			(async () => {
				setIsLoad(true);
				const resp = await getElementsId(slug, handleNotify);
				setIsLoad(false);

				if (resp.isSuccess) {
					setItensFromElement(resp.data);
				}
			})();
		}
	}, [respFakeItem]);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({
			...value,
			title: `${t('menuItens.title')} - ${slug}`
		}));
	}, [i18n?.language]);

	//reseta componente quando ele é destruido
	useEffect(() => {
		return () => {
			setItensFromElement([]);
		};
	}, []);

	return (
		<S.container>
			{isLoad ? (
				<S.centralize>
					<Load showText text={t('itemMenuSelected.searchingItens')} />
				</S.centralize>
			) : (
				<>
					<S.btns>
						<AddBtn
							anyFunction={() => {
								setIsFormOpen(true);
							}}
							text={t('itemMenuSelected.addItenOnList')}
						/>
						<S.backBtn onClick={() => navigate(-1)}>
							<IoArrowBackCircleOutline /> <p>{t('itemMenuSelected.back')}</p>
						</S.backBtn>
					</S.btns>

					<S.containerItens>
						{itensFromElement.length > 0 ? (
							<S.listItens>
								{itensFromElement.map((item) => (
									<ItemFromItemMenu
										slug={slug || ''}
										key={item.id}
										item={item}
										title={`${t('formItemMenuSelected.name')}: ${item.name}`}
									/>
								))}
							</S.listItens>
						) : (
							<S.centralize>
								<p>{t('itemMenuSelected.noItens')}</p>
							</S.centralize>
						)}
					</S.containerItens>
				</>
			)}

			{isFormOpen && <FormItemMenuSelected slug={slug || ''} />}
		</S.container>
	);
}
